import { eTipoPermissao } from '@/enums/ePermissoes';

/*
 * REGISTRO DE ENTREGA DE REMATRÍCULA — migração de `MenuAcademico/ControleRematricula.aspx`: a
 * turma inteira numa grade, marcando quem entregou a rematrícula (`ENTURMACAO.CARTAENTREGUE`).
 *
 * Permissão PRÓPRIA (300200499), vizinha da legada (300200400) — nunca a do legado.
 * Ver docs/controle-rematricula/README.md.
 */
export default [
  {
    description: 'Registro de Entrega de Rematrícula',
    path: '/academico/controlerematricula',
    name: 'controle_rematricula',
    component: () => import('@/views/academico/controlerematricula/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.REGISTRODEENTREGADEREMATRICULANOVO_MENU_300200499],
    },
    goesToMenu: true,
  },
];
